export const clearAllFilters = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("studentData");
    localStorage.removeItem("studentToken");
    localStorage.removeItem("role");
    localStorage.removeItem("emp_id");
    localStorage.removeItem("emp_name");
    localStorage.removeItem("placementFilterState");
    localStorage.removeItem("placementDbFilters");
    localStorage.removeItem("placedStudentFilters");
    localStorage.removeItem("jobDashboardFilters");
    localStorage.removeItem("jobDashboard-selectedColumns");
    sessionStorage.removeItem("lastActiveTab");
    sessionStorage.removeItem("lastJobReqPath");
};
